import type { FaireProductEntity } from "../../entity_types/product";

export const p_q53mgt2fzz: FaireProductEntity = {
  token: "p_q53mgt2fzz",
  type: "product",
  name: "Hallowe'en Spree Vintage Inspired Mug",
  brandToken: "b_2900neba77",
  brandName: "Meagan Meli Illustration",
  imageUrl:
    "https://cdn.faire.com/fastly/974333b44fae9c23f089aaa16ee2276cd4deb9f4aa419028ce617aa9cfa23ebf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f08bf825656a8f5f1e93e6942960c231e657416ff08f4fcf491b80db5ea2768b.jpeg",
    "https://cdn.faire.com/fastly/f131ed7872118fbcd9c652d55e82ae89b8d9a20984fe06aba859165a82f2de61.jpeg",
    "https://cdn.faire.com/fastly/374a727ff77958e44ec28117bc1cc7de0de22e6df7d67ac36d76e53320426c6c.jpeg",
    "https://cdn.faire.com/fastly/d02804621dc3409c09b59459efc8c2a0859dfc78d172e0f6f8a162670af172d2.jpeg",
    "https://cdn.faire.com/fastly/4013d4de7b4190056a72120ce77cd4b5bce8d842f2780eb1661571367dfb95f0.jpeg",
  ],
  priceDollars: 9.5,
  description:
    "This Halloween mug is inspired by Vintage Halloween pieces from the 80s! This mug has it all: 13oz capacity, no lead content, eco-friendly inks, a wrap-around image that is dishwasher and microwave safe, all in a lightweight glass package! Modernize your vintage mug collection without compromising on your spooky style!",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:46.196Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
